import _ from 'underscore';
import { Validation } from '@bingads-webui/validation';

/**
 * define rules for string property
 * @param {Object} prop - property define
 * @param {Rules} extraRules - extended rules for this property
 * @param {I18n} i18n - get error message for rules
 * @returns {Rules} - return rule with property define and extra rules
 */
export function StringRules(prop, extraRules, i18n) {
  const rules = {};

  if (_.isFinite(prop.maxLength)) {
    rules.maxLength = Validation.string.size(prop.maxLength, prop.distinguishCJK, i18n);
  }

  if (prop.pattern) {
    rules.pattern = Validation.string.pattern(prop.pattern, i18n);
  }

  return _.extend(rules, extraRules);
}
